var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThirdStep(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 306 250",
    style: {
      enableBackground: "new 0 0 306 250"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 148.3727,
    y1: 14.1274,
    x2: 154.3251,
    y2: 273.0555
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FED184"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9A76F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M279.792,250H26.624c-13.918,0-24.837-11.857-24.389-26.405L8.375,24.047 C8.785,10.736,19.826,0,33.039,0h240.337c13.213,0,24.254,10.736,24.664,24.047l6.141,199.548 C304.629,238.143,293.711,250,279.792,250z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F57F37"
    },
    d: "M74.915,80.875c0.426,0.008,0.833-0.07,1.205-0.219l2.179,5.469 c-0.359,0.144-0.698,0.353-0.994,0.638c-1.231,1.183-1.269,3.141-0.086,4.371c1.183,1.231,3.141,1.269,4.371,0.086 c0.301-0.29,0.529-0.626,0.687-0.987l5.412,2.328c-0.147,0.35-0.236,0.73-0.244,1.132c-0.034,1.707,1.323,3.118,3.03,3.152 c1.707,0.034,3.118-1.323,3.152-3.03c0.008-0.422-0.07-0.826-0.216-1.196l5.471-2.18c0.144,0.355,0.351,0.691,0.633,0.984 c1.183,1.231,3.141,1.269,4.371,0.086c1.231-1.183,1.269-3.141,0.086-4.371c-0.303-0.315-0.657-0.549-1.036-0.708l2.326-5.408 c0.363,0.16,0.762,0.253,1.183,0.261c1.707,0.034,3.118-1.323,3.152-3.03c0.034-1.707-1.323-3.118-3.03-3.152 c-0.453-0.009-0.882,0.086-1.273,0.253l-2.181-5.475c0.385-0.143,0.748-0.364,1.064-0.667c1.231-1.183,1.269-3.141,0.086-4.371 c-1.183-1.231-3.141-1.269-4.371-0.086c-0.333,0.32-0.571,0.698-0.728,1.101l-5.418-2.331c0.177-0.379,0.283-0.798,0.292-1.243 c0.034-1.707-1.323-3.118-3.03-3.152c-1.707-0.034-3.118,1.323-3.152,3.03c-0.009,0.457,0.088,0.889,0.258,1.282l-5.477,2.182 c-0.143-0.389-0.364-0.756-0.669-1.074c-1.183-1.231-3.141-1.269-4.372-0.086c-1.231,1.183-1.269,3.141-0.086,4.371 c0.306,0.319,0.666,0.554,1.05,0.712l-2.327,5.408c-0.366-0.163-0.77-0.258-1.197-0.266c-1.707-0.034-3.118,1.323-3.152,3.03 C71.852,79.43,73.208,80.841,74.915,80.875z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    cx: 90.808,
    cy: 77.534,
    r: 5.111
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M98.94,71.616 c1.208,1.656,1.921,3.696,1.925,5.902c0.009,5.554-4.487,10.064-10.041,10.072S80.76,83.103,80.752,77.549 c-0.009-5.554,4.487-10.064,10.041-10.072"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#F57F37",
      strokeWidth: 0.5,
      strokeMiterlimit: 10,
      strokeDasharray: "3.0247,3.0247"
    },
    cx: 90.808,
    cy: 77.534,
    r: 24.076
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F57F37"
    },
    d: "M142.06,69.397c-0.325-0.089-0.652-0.109-0.966-0.067l-0.605-4.615 c0.303-0.04,0.604-0.135,0.886-0.295c1.174-0.667,1.584-2.16,0.917-3.333c-0.667-1.174-2.16-1.584-3.333-0.917 c-0.287,0.163-0.527,0.377-0.718,0.622l-3.694-2.837c0.18-0.239,0.323-0.513,0.408-0.82c0.358-1.302-0.407-2.647-1.709-3.005 c-1.302-0.358-2.647,0.407-3.005,1.709c-0.089,0.322-0.107,0.646-0.067,0.958l-4.617,0.605c-0.041-0.3-0.135-0.598-0.294-0.878 c-0.667-1.174-2.16-1.584-3.333-0.917c-1.174,0.667-1.584,2.16-0.917,3.333c0.171,0.3,0.397,0.549,0.656,0.744l-2.835,3.691 c-0.247-0.193-0.534-0.342-0.855-0.43c-1.302-0.358-2.647,0.407-3.005,1.709c-0.358,1.302,0.407,2.647,1.709,3.005 c0.345,0.095,0.693,0.106,1.025,0.054l0.606,4.62c-0.323,0.035-0.644,0.133-0.945,0.304c-1.174,0.667-1.584,2.16-0.917,3.333 c0.667,1.174,2.16,1.584,3.333,0.917c0.317-0.18,0.573-0.424,0.772-0.702l3.698,2.841c-0.209,0.256-0.373,0.556-0.466,0.896 c-0.358,1.302,0.407,2.647,1.709,3.005c1.302,0.358,2.647-0.407,3.005-1.709c0.096-0.348,0.106-0.698,0.052-1.033l4.622-0.606 c0.034,0.326,0.132,0.65,0.304,0.953c0.667,1.174,2.16,1.584,3.333,0.917c1.174-0.667,1.584-2.16,0.917-3.333 c-0.173-0.304-0.402-0.554-0.666-0.75l2.835-3.691c0.249,0.196,0.54,0.347,0.865,0.437c1.302,0.358,2.647-0.407,3.005-1.709 C144.127,71.101,143.362,69.755,142.06,69.397z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    cx: 129.231,
    cy: 68.864,
    r: 4.041
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 0.5,
      strokeMiterlimit: 10
    },
    d: "M121.848,71.817 c-0.603-1.504-0.753-3.206-0.326-4.898c1.074-4.258,5.397-6.838,9.655-5.764c4.258,1.074,6.838,5.397,5.764,9.655 s-5.397,6.838-9.655,5.764"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2F27CE"
    },
    d: "M94.676,79.365h-4.225c-4.948,0-9.114,3.698-9.702,8.61l-11.55,96.529 c-0.696,5.815,3.845,10.932,9.702,10.932h8.831L94.676,79.365z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4840D5"
    },
    d: "M82.771,85.419v109.869c0,4.432,3.651,7.994,8.082,7.885l144.679-3.572 c4.381-0.108,7.834-3.767,7.688-8.148l-3.454-103.615c-0.14-4.193-3.538-7.543-7.733-7.623L90.808,77.534 C86.395,77.45,82.771,81.005,82.771,85.419z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9AE1F8"
    },
    d: "M90.708,89.983l0.914,98.925c0.023,2.497,2.103,4.489,4.616,4.423l139.963-3.707 c2.768-0.073,4.812-2.584,4.299-5.286c-2.318-12.215-7.774-43.281-6.984-61.322c0.622-14.213,0.857-23.422,0.945-28.347 c0.044-2.437-1.886-4.458-4.34-4.543L95.36,85.479C92.801,85.391,90.685,87.44,90.708,89.983z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#11C2B6"
    },
    d: "M115.804,125.516l-10.54-0.122c-1.816-0.021-3.322-1.338-3.361-2.943l-0.228-9.416 c-0.039-1.612,1.409-2.887,3.231-2.847l10.574,0.231c1.791,0.039,3.267,1.363,3.3,2.956l0.194,9.307 C119.007,124.268,117.589,125.537,115.804,125.516z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E2F7FD"
    },
    d: "M134.615,125.733l-10.27-0.119c-1.769-0.02-3.232-1.32-3.265-2.904l-0.19-9.293 c-0.033-1.591,1.383-2.85,3.157-2.811l10.303,0.225c1.745,0.038,3.179,1.344,3.206,2.917l0.158,9.187 C137.74,124.501,136.355,125.753,134.615,125.733z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E2F7FD"
    },
    d: "M152.948,125.945l-10.011-0.116c-1.724-0.02-3.146-1.303-3.172-2.867l-0.154-9.173 c-0.026-1.57,1.357-2.813,3.087-2.775l10.041,0.219c1.701,0.037,3.094,1.326,3.115,2.879l0.123,9.07 C155.999,124.728,154.644,125.964,152.948,125.945z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1AC10"
    },
    d: "M170.823,126.151l-9.761-0.113c-1.681-0.019-3.063-1.286-3.083-2.83l-0.119-9.057 c-0.02-1.55,1.333-2.778,3.018-2.741l9.79,0.214c1.659,0.036,3.013,1.309,3.028,2.842l0.09,8.956 C173.802,124.949,172.477,126.17,170.823,126.151z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E2F7FD"
    },
    d: "M188.255,126.352l-9.52-0.11c-1.639-0.019-2.983-1.269-2.997-2.794l-0.086-8.943 c-0.015-1.531,1.309-2.743,2.953-2.707l9.548,0.209c1.618,0.035,2.935,1.292,2.945,2.806l0.058,8.844 C191.165,125.164,189.868,126.371,188.255,126.352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E2F7FD"
    },
    d: "M205.262,126.549l-9.288-0.107c-1.599-0.018-2.906-1.253-2.915-2.759l-0.055-8.832 c-0.009-1.512,1.286-2.709,2.889-2.674l9.314,0.203c1.578,0.034,2.859,1.275,2.864,2.77l0.029,8.736 C208.105,125.375,206.836,126.567,205.262,126.549z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E2F7FD"
    },
    d: "M221.946,126.741l-8.32-0.096c-1.509-0.017-2.738-1.197-2.742-2.636l-0.024-8.889 c-0.004-1.445,1.222-2.59,2.735-2.557l8.343,0.182c1.491,0.033,2.698,1.219,2.698,2.649v8.8 C224.636,125.618,223.433,126.758,221.946,126.741z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E2F7FD"
    },
    d: "M116.247,146.128l-10.494,0.027c-1.808,0.005-3.307-1.281-3.346-2.873l-0.226-9.339 c-0.039-1.599,1.403-2.884,3.217-2.87l10.528,0.081c1.783,0.014,3.252,1.307,3.285,2.887l0.193,9.231 C119.436,144.845,118.025,146.124,116.247,146.128z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1AC10"
    },
    d: "M134.977,146.081l-10.226,0.026c-1.761,0.004-3.218-1.265-3.25-2.836l-0.188-9.218 c-0.032-1.578,1.377-2.847,3.144-2.833l10.258,0.079c1.738,0.013,3.165,1.289,3.192,2.849l0.156,9.113 C138.089,144.814,136.709,146.076,134.977,146.081z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E2F7FD"
    },
    d: "M153.233,146.034l-9.969,0.025c-1.717,0.004-3.132-1.249-3.158-2.8l-0.153-9.1 c-0.026-1.558,1.352-2.81,3.074-2.797l9.999,0.077c1.694,0.013,3.081,1.273,3.102,2.813l0.122,8.998 C156.271,144.784,154.922,146.03,153.233,146.034z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E2F7FD"
    },
    d: "M171.034,145.989l-9.721,0.025c-1.674,0.004-3.05-1.233-3.07-2.765l-0.118-8.985 c-0.02-1.538,1.327-2.775,3.006-2.762l9.75,0.075c1.652,0.013,3.001,1.257,3.016,2.777l0.089,8.886 C174.001,144.755,172.681,145.985,171.034,145.989z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E2F7FD"
    },
    d: "M188.396,145.945l-9.482,0.024c-1.633,0.004-2.971-1.218-2.985-2.731l-0.086-8.873 c-0.015-1.519,1.304-2.74,2.941-2.728l9.509,0.073c1.611,0.012,2.923,1.241,2.933,2.743l0.058,8.776 C191.295,144.726,190.003,145.941,188.396,145.945z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E2F7FD"
    },
    d: "M205.336,145.902l-9.252,0.023c-1.593,0.004-2.894-1.203-2.903-2.697l-0.055-8.764 c-0.009-1.5,1.281-2.707,2.878-2.694l9.278,0.071c1.572,0.012,2.848,1.225,2.853,2.709l0.028,8.669 C208.168,144.698,206.904,145.898,205.336,145.902z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E2F7FD"
    },
    d: "M221.956,145.86l-8.288,0.021c-1.503,0.004-2.727-1.15-2.731-2.578l-0.024-8.822 c-0.004-1.434,1.217-2.587,2.725-2.576l8.311,0.064c1.486,0.011,2.688,1.172,2.688,2.591v8.733 C224.636,144.708,223.438,145.857,221.956,145.86z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E2F7FD"
    },
    d: "M116.687,166.573l-10.448,0.172c-1.8,0.03-3.293-1.225-3.331-2.804l-0.224-9.262 c-0.038-1.585,1.397-2.881,3.203-2.892l10.481-0.067c1.775-0.011,3.238,1.251,3.271,2.818l0.191,9.156 C119.862,165.256,118.457,166.544,116.687,166.573z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E2F7FD"
    },
    d: "M135.336,166.265l-10.182,0.168c-1.754,0.029-3.204-1.21-3.236-2.769l-0.187-9.143 c-0.032-1.565,1.371-2.844,3.13-2.855l10.214-0.065c1.73-0.011,3.152,1.235,3.178,2.783l0.155,9.04 C138.435,164.965,137.061,166.237,135.336,166.265z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E2F7FD"
    },
    d: "M153.515,165.965l-9.927,0.164c-1.709,0.028-3.119-1.196-3.145-2.734l-0.151-9.027 c-0.026-1.545,1.346-2.807,3.061-2.818l9.957-0.063c1.687-0.011,3.069,1.22,3.089,2.748l0.121,8.927 C156.541,164.682,155.197,165.937,153.515,165.965z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1AC10"
    },
    d: "M171.243,165.673l-9.681,0.16c-1.667,0.028-3.037-1.181-3.057-2.701l-0.117-8.914 c-0.02-1.526,1.322-2.772,2.994-2.783l9.71-0.062c1.645-0.01,2.988,1.205,3.004,2.714l0.089,8.816 C174.198,164.406,172.884,165.646,171.243,165.673z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E2F7FD"
    },
    d: "M188.536,165.387l-9.444,0.156c-1.626,0.027-2.959-1.167-2.973-2.668l-0.085-8.804 c-0.015-1.507,1.298-2.738,2.929-2.748l9.471-0.06c1.605-0.01,2.911,1.191,2.921,2.681l0.058,8.709 C191.423,164.137,190.136,165.361,188.536,165.387z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1AC10"
    },
    d: "M205.409,165.109l-9.216,0.152c-1.586,0.026-2.883-1.154-2.892-2.636l-0.054-8.697 c-0.009-1.489,1.276-2.704,2.867-2.714l9.242-0.059c1.566-0.01,2.837,1.176,2.842,2.649l0.028,8.603 C208.231,163.874,206.971,165.083,205.409,165.109z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E2F7FD"
    },
    d: "M221.966,164.835l-8.257,0.136c-1.497,0.025-2.717-1.103-2.721-2.521l-0.024-8.755 c-0.004-1.423,1.213-2.585,2.714-2.594l8.279-0.053c1.48-0.009,2.678,1.126,2.678,2.534v8.668 C224.636,163.655,223.442,164.811,221.966,164.835z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E2F7FD"
    },
    d: "M117.123,186.853l-10.402,0.316c-1.792,0.054-3.278-1.17-3.316-2.736l-0.223-9.187 c-0.038-1.573,1.391-2.878,3.189-2.914l10.435-0.212c1.768-0.036,3.224,1.196,3.256,2.751l0.19,9.083 C120.284,185.502,118.885,186.799,117.123,186.853z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1AC10"
    },
    d: "M135.692,186.289l-10.139,0.308c-1.746,0.053-3.19-1.156-3.222-2.702l-0.185-9.07 c-0.032-1.553,1.366-2.841,3.117-2.876l10.171-0.206c1.723-0.035,3.138,1.182,3.165,2.717l0.154,8.968 C138.778,184.956,137.41,186.237,135.692,186.289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E2F7FD"
    },
    d: "M153.795,185.739l-9.886,0.3c-1.702,0.052-3.106-1.143-3.132-2.67l-0.15-8.956 c-0.026-1.533,1.341-2.804,3.048-2.839l9.916-0.201c1.68-0.034,3.056,1.168,3.076,2.684l0.12,8.857 C156.809,184.424,155.47,185.688,153.795,185.739z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E2F7FD"
    },
    d: "M171.451,185.203l-9.642,0.293c-1.66,0.05-3.025-1.13-3.045-2.638l-0.116-8.844 c-0.02-1.514,1.317-2.769,2.982-2.803l9.67-0.196c1.639-0.033,2.976,1.154,2.991,2.652l0.088,8.748 C174.394,183.905,173.085,185.153,171.451,185.203z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E2F7FD"
    },
    d: "M188.675,184.68l-9.406,0.286c-1.619,0.049-2.947-1.117-2.961-2.607l-0.084-8.736 c-0.014-1.495,1.293-2.735,2.917-2.768l9.434-0.191c1.599-0.032,2.9,1.141,2.91,2.62l0.057,8.642 C191.55,183.399,190.269,184.631,188.675,184.68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E2F7FD"
    },
    d: "M205.482,184.169l-9.18,0.279c-1.58,0.048-2.871-1.105-2.881-2.576l-0.054-8.63 c-0.009-1.477,1.271-2.701,2.856-2.733l9.206-0.187c1.56-0.032,2.826,1.128,2.831,2.589l0.028,8.538 C208.293,182.905,207.038,184.122,205.482,184.169z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E2F7FD"
    },
    d: "M221.976,183.668l-8.225,0.25c-1.492,0.045-2.706-1.057-2.71-2.464l-0.024-8.689 c-0.004-1.412,1.208-2.582,2.704-2.613l8.248-0.167c1.475-0.03,2.668,1.08,2.668,2.478v8.603 C224.636,182.459,223.447,183.624,221.976,183.668z"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#4840D5"
    },
    cx: 123.446,
    cy: 94.246,
    r: 3.968
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#4840D5"
    },
    cx: 154.2,
    cy: 95.238,
    r: 3.968
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#4840D5"
    },
    cx: 185.946,
    cy: 96.23,
    r: 3.968
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#4840D5"
    },
    cx: 216.7,
    cy: 97.222,
    r: 3.968
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M110.549,107.143L110.549,107.143c-1.096,0-1.984-0.888-1.984-1.984v-3.968 c0-1.096,0.888-1.984,1.984-1.984h0c1.096,0,1.984,0.888,1.984,1.984v3.968C112.533,106.255,111.645,107.143,110.549,107.143z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M126.422,108.135L126.422,108.135c-1.096,0-1.984-0.888-1.984-1.984v-3.968 c0-1.096,0.888-1.984,1.984-1.984h0c1.096,0,1.984,0.888,1.984,1.984v3.968C128.406,107.247,127.518,108.135,126.422,108.135z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M146.263,108.135L146.263,108.135c-1.096,0-1.984-0.888-1.984-1.984v-3.968 c0-1.096,0.888-1.984,1.984-1.984l0,0c1.096,0,1.984,0.888,1.984,1.984v3.968C148.248,107.247,147.359,108.135,146.263,108.135z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M166.105,109.127L166.105,109.127c-1.096,0-1.984-0.888-1.984-1.984v-3.968 c0-1.096,0.888-1.984,1.984-1.984l0,0c1.096,0,1.984,0.888,1.984,1.984v3.968C168.089,108.239,167.201,109.127,166.105,109.127z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M183.962,110.119L183.962,110.119c-1.096,0-1.984-0.888-1.984-1.984v-3.968 c0-1.096,0.888-1.984,1.984-1.984h0c1.096,0,1.984,0.888,1.984,1.984v3.968C185.946,109.231,185.058,110.119,183.962,110.119z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M202.811,110.119L202.811,110.119c-1.096,0-1.984-0.888-1.984-1.984v-3.968 c0-1.096,0.888-1.984,1.984-1.984l0,0c1.096,0,1.984,0.888,1.984,1.984v3.968C204.795,109.231,203.907,110.119,202.811,110.119z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M217.706,111h-0.028c-1.088,0-1.97-0.882-1.97-1.97v-3.885c0-1.088,0.882-1.97,1.97-1.97h0.028 c1.088,0,1.97,0.882,1.97,1.97v3.885C219.676,110.118,218.794,111,217.706,111z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#11B3EE"
    },
    d: "M123.944,95.238c-0.042,0-0.083-0.002-0.125-0.005c-0.82-0.068-1.428-0.787-1.36-1.606 c0.884-10.616-0.021-22.759-2.73-23.21c-1.569-0.26-2.822,0.009-3.823,0.826c-2.08,1.698-2.656,5.442-2.702,6.741 c-0.104,0.011-2.84-0.074-2.974-0.082c0.009-0.246,0.256-6.075,3.793-8.965c1.68-1.372,3.767-1.862,6.196-1.457 c6.778,1.13,5.7,20.487,5.207,26.393C125.36,94.651,124.709,95.238,123.944,95.238z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#11B3EE"
    },
    d: "M154.698,96.23c-0.042,0-0.083-0.002-0.125-0.005c-0.82-0.068-1.428-0.787-1.36-1.606 c0.884-10.616-0.021-22.759-2.73-23.21c-1.569-0.26-2.822,0.009-3.823,0.826c-2.08,1.698-2.656,5.071-2.703,6.37 c-0.454-0.015-2.779-0.14-2.974-0.107c0.009-0.246,0.257-5.679,3.794-8.568c1.68-1.372,3.766-1.862,6.196-1.457 c6.778,1.13,5.7,20.487,5.207,26.393C156.114,95.643,155.463,96.23,154.698,96.23z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#11B3EE"
    },
    d: "M186.444,97.222c-0.042,0-0.083-0.002-0.125-0.005c-0.82-0.068-1.428-0.787-1.36-1.606 c0.884-10.616-0.021-22.759-2.73-23.21c-1.569-0.261-2.822,0.009-3.823,0.826c-2.08,1.698-2.568,4.622-2.614,5.921 c-0.413,0.015-2.974-0.057-2.974-0.057c0.009-0.246,0.168-5.279,3.705-8.169c1.68-1.372,3.768-1.862,6.196-1.457 c6.778,1.13,5.7,20.487,5.207,26.393C187.86,96.635,187.209,97.222,186.444,97.222z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#11B3EE"
    },
    d: "M217.198,98.214c-0.042,0-0.083-0.002-0.125-0.005c-0.82-0.068-1.428-0.787-1.36-1.606 c0.884-10.616-0.021-22.759-2.73-23.21c-1.568-0.261-2.822,0.009-3.823,0.826c-2.08,1.698-2.382,4.203-2.428,5.502 c-0.378,0.029-2.397-0.01-2.974-0.043c0.009-0.246-0.018-4.875,3.519-7.764c1.68-1.372,3.767-1.862,6.196-1.457 c6.778,1.13,5.7,20.487,5.207,26.393C218.614,97.627,217.963,98.214,217.198,98.214z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThirdStep);
export default __webpack_public_path__ + "static/media/third_step.e964ce683f8e683ffee7105487cee886.svg";
export { ForwardRef as ReactComponent };